import { VipLevel } from '@/constants/subscription';
export interface UpgradeInfo {
  show_pop: boolean;
}

export interface UpgradeResponse {
  status: number;
  data: UpgradeInfo;
}

export interface FetchUserTokenParams {
  app_id?: string;
  gid?: string;
  code?: string;
  token?: string;
  client_id?: string;
}

export interface FetchUserTokenResponse {
  data: {
    access_token: string;
  };
}

export enum Method {
  // 手机号
  PHONE = 108,
  // 微信
  WECHART = 103,
  // QQ
  QQ = 101,
  // 微博
  WEIBO = 102,
  // facebook
  FACEBOOK = 104,
  // google
  GOOGLE = 105,
  // 邮箱
  EMAIL = 106,
  // apple
  APPLE = 110,
  // huawei
  HUAWEI = 111,
}

export interface LoginMethodItem {
  content: string;
  icon: Method;
  method: string;
}

export interface FetchUserInfoResponse {
  code: number;
  message: string;
  data: {
    access_token: string;
    userInfo: UserInfo;
    vipInfo: VipInfo;
    cutoutInfo: CutoutInfo;
    teamInfo: { my_role?: string };
  };
}

export interface UserInfo {
  avatar: string;
  id: number;
  screen_name: string;
  login_methods?: LoginMethodItem[];
  /**
   * 是否来自服务市场用户
   */
  ban_purchase?: boolean;
}

export interface VipInfo {
  // 是否有会员is_vip=true表示有会员
  is_vip?: boolean;
  /** 会员等级：0 非会员，1/2 普通会员，3 高级会员 */
  vip_level?: VipLevel;
  // 当is_vip=true返回具体会员过期时间，-1表示无
  vip_end_time?: number;
  is_hbp_vip?: boolean;
  is_xx_vip?: boolean; // 是否是普粉会员，仅当is_vip=false时该值才可能是true
  vip_days?: number; // 有会员就是正数，过期就是负数
  sub_type?: number; // 会员订阅类型 0:赠送 1:非续期 2:续期
  sub_period?: number; // 会员订阅周期 0: 天 1:月 2:季 3:年 4:三天 5:周
}

// 抠图权益信息
export interface CutoutInfo {
  // 权益总数
  total: number;
  // 剩余权益总数
  left: number;
  // 权益细分明细
  details?: CutoutInfoDetail[];
}

export enum CutoutNumberType {
  // 1-永久型
  PERMANENT = 1,
  // 2=期限计量型
  TIMELIMIT = 2,
}

export interface CutoutInfoDetail {
  // 类型：1-永久型；2=期限计量型
  type: CutoutNumberType;
  // 剩余量（即原始总量-已经使用量）
  num_left: number;
  // 原始总量
  num_total: number;
  // 生效开始时间，单位秒
  valid_time: number;
  // 生效结束时间，单位秒
  invalid_time: number;
  // 剩余有效天数，当type=2时该值有值，>0表示有剩余可用天数
  days_left: number;
}

export interface GetAccesTokenByCookieResponse {
  meta: {
    code: number;
    msg: string;
    error: string;
    request_uri: string;
    request_id: string;
    sid: string;
    client_ip: string;
    idc: string;
  };
  response: {
    access_token: string;
  };
}

/**
 * 接口 [获取用户跨应用会员信息(H5)]的返回数据
 * @docs: /h5/user/user_info.json
 */
export interface UserInfoResponse {
  /**
   * code标记请求状态是否成功。0：成功1：失败
   */
  code: number;
  /**
   * 错误码，当code为0时，错误码为”00000“；当错误码不为00000时，需要有错误码，错误码为5位字符串
   */
  error_code: string;
  /**
   * code为1，message记录错误信息；code为0，message为“success”
   */
  message: string;
  /**
   * 会员信息
   */
  data: {
    /**
     * 账号类型(1: uid 2: gid)
     */
    account_type: number;
    /**
     * 账号Id(buyer_type为1 时为uid，buyer_type为2时为gid)
     */
    account_id: number;
    /**
     * 当前是否是会员
     */
    is_vip: boolean;
    /**
     * 会员权益能否使用
     */
    use_vip: boolean;
    /**
     * 会员权益限制使用原因：0:无，1.设备限制
     */
    limit_type?: number;
    /**
     * 会员生效时间
     */
    valid_time?: number;
    /**
     * 会员失效时间
     */
    invalid_time?: number;
    /**
     * 会员来源类型: 1普通会员 2 学生会员
     */
    derive_type?: number;
    /**
     * 会员来源名称
     */
    derive_type_name?: string;
    /**
     * 会员状态文案
     */
    vip_status_tips?: string;
    /**
     * 会员信息
     */
    membership?: {
      /**
       * 会员Id
       */
      id?: number;
      /**
       * 会员名称
       */
      display_name?: string;
      /**
       * 会员等级
       */
      level?: number;
      /**
       * 会员等级名称
       */
      level_name?: string;
    };
    /**
     * 有效的会员对应的应用ID，会员最长的排最前面
     */
    app_valid_vip_list?: {
      app_id: string;
      app_name: string;
      invalidate_time: number;
    }[];
  };
}

/**
 * 接口 [[团队]获取团队信息]的返回数据
 * @docs: /enterprise/team/info
 */
export interface TeamInfoResponse {
  reqid?: string;
  code?: number;
  data?: {
    oid?: number;
    corp_id?: string;
    name?: string;
    type?: number;
    logo?: string;
    user_count?: number;
    super_admin_name?: string;
    industry_id?: number;
    industry_name?: string;
    created_at?: number;
    /**
     * 席位详情
     */
    member_detail?: {
      /**
       * 席位总数
       */
      total?: number;
      /**
       * 有效的席位数
       */
      valid_num?: number;
      /**
       * 生效可操作席位数
       */
      operable_num?: number;
      /**
       * 生效可操作席位绑定用户数
       */
      operable_bind_num?: number;
      /**
       * 成员数
       */
      user_count?: number;
    };
    /**
     * 所有者信息
     */
    super_admin?: {
      uid: string;
      name: string;
      phone: string;
      phone_cc: string;
    };
    active_order?: {
      /**
       * 来源: 1-订单，2-订阅后台，3-兑换，4-礼品卡，5-活动，6-客服，7-订阅开放平台
       */
      ref_provider: number;
      /**
       * 当前生效订单会员的有效期
       */
      vip_end_time?: number;
    };
  };
}

/**
 * 接口 [[团队]获取我的成员信息]的返回数据
 * @docs: /enterprise/team/member_info
 */
export interface MemberInfoResponse {
  reqid?: string;
  code?: number;
  data?: {
    role?: string;
    /**
     * 是否有席位 0 没有 1有
     */
    has_seat?: number;
    /**
     * 我的席位状态，0-未绑定 1-生效 2-待生效 10-冻结（过期）
     */
    seat_status?: number;
    /**
     * 我的席位冻结时间
     */
    invalidate_time?: number;
    team?: {
      member_detail?: {
        total?: number;
        valid_num?: number;
        invalid_num?: number;
        operable_num?: number;
        operable_bind_num?: number;
        user_count?: number;
        /**
         * 席位冻结时间
         */
        earliest_invalidate_time?: number;
      };
      is_vip?: boolean;
      vip_end_time?: number;
    };
  };
}

export interface DayNum {
  /**
   * 剩余有效天数
   */
  day: number;
  /**
   * 对应的美豆（美叶）数
   */
  num: number;
}

export interface FetchZhankuManagerResponse {
  code: number;
  data: {
    manager: string;
    phone: string;
  };
}

export interface FetchRebateCodeResponse {
  code: number;
  message: string;
  data: {
    rebate_code: string;
  };
}
